<template>
  <div class="contact_form">
    <p v-if="formData.error" class="formData_error">メールを送信できませんでした。<br>入力項目の確認を再度お願いいたします。</p>
    <div class="form_area">
      <dl class="form_parts">
        <dt class="parts_ttl require">お名前</dt>
        <dd class="parts_ele">
          <input ref="name" type="text" v-bind:value="formData.name" placeholder="山田太郎" required>
          <p class="error" v-if="!name.value">必須項目です。入力してください。</p>
          <p class="error" v-else-if="!name.validate">入力形式が間違っています。</p>
        </dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl require">フリガナ</dt>
        <dd class="parts_ele">
          <input ref="ruby" type="text" v-bind:value="formData.ruby" placeholder="ヤマダタロウ" required>
          <p class="error" v-if="!ruby.value">必須項目です。入力してください。</p>
          <p class="error" v-else-if="!ruby.validate">入力形式が間違っています。</p>
        </dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl require">電話番号</dt>
        <dd class="parts_ele">
          <input ref="tel" type="tel" v-bind:value="formData.tel" placeholder="09012345678 （ハイフンなし）" required>
          <p class="error" v-if="!tel.value">必須項目です。入力してください。</p>
          <p class="error" v-else-if="!tel.validate">入力形式が間違っています。</p>
        </dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl require">メールアドレス</dt>
        <dd class="parts_ele">
          <input ref="mail" type="email" v-bind:value="formData.mail" placeholder="例）aaa@example.com" required>
          <p class="error" v-if="!mail.value">必須項目です。入力してください。</p>
          <p class="error" v-else-if="!mail.validate">入力形式が間違っています。</p>
        </dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl require">備考</dt>
        <dd class="parts_ele">
          <textarea ref="comment" placeholder="お問い合わせ内容を入力してください。" required>{{formData.comment}}</textarea>
          <p class="error" v-if="!comment.value">必須項目です。入力してください。</p>
          <p class="error" v-else-if="!comment.validate">入力形式が間違っています。</p>
        </dd>
      </dl>
    </div>
    <div class="form_btn"><button class="btn" @click="confirm">確認する</button></div>
  </div>
</template>

<script>
export default {
  name: 'InputTmp',
  props: {
    formData: Object
  },
  data () {
    return {
      name: {value: true, validate: true},
      ruby: {value: true, validate: true},
      tel: {value: true, validate: true},
      mail: {value: true, validate: true},
      comment: {value: true, validate: true}
    }
  },
  methods: {
    confirm () {
      const existValues = this.exsistValues();
      const validateValues = this.validateValues();
      if (!existValues || !validateValues) {
        if (!existValues) console.log('Value Error : ', existValues);
        if (!validateValues) console.log('Validate Error : ', validateValues);
        this.$emit('change-page', 'input', this.collectValue());
        return;
      }
      this.$emit('change-page', 'confirm', this.collectValue());
    },
    collectValue () {
      const vueThis = this;
      const inputData = {};
      Object.keys(vueThis.$refs).forEach(function(key){
        inputData[key] = vueThis.htmlspecialchars( vueThis.$refs[key].value );
      });
      return inputData;
    },
    exsistValues () {
      const vueThis = this;
      const inputRequiredKeys = Object.keys(vueThis.$refs).filter(function(key){
        return vueThis.$refs[key].required;
      });
      inputRequiredKeys.forEach(function(key){
        vueThis[key].value = vueThis.$refs[key] ? (vueThis.$refs[key].value ? true : false) : true;
      });
      if (inputRequiredKeys.some(function(key){return !vueThis[key].value})) {
        return false;
      }
      return true;
    },
    validateValues () {
      this.name.validate = this.$refs.name ? (this.$refs.name.value ? true : false) : true;
      this.ruby.validate = this.$refs.ruby ? (this.$refs.ruby.value ? true : false) : true;
      this.tel.validate = this.$refs.tel ? (this.validateTel(this.$refs.tel.value)) : true;
      this.mail.validate = this.$refs.mail ? (this.validateMail(this.$refs.mail.value)) : true;
      this.comment.validate = this.$refs.comment ? (this.$refs.comment.value ? true : false) : true;
      if (this.name.validate && this.ruby.validate && this.tel.validate && this.mail.validate && this.comment.validate) {
        return true;
      }
      return false;
    },
    validateTel (telNumber) {
      const tel = telNumber.replace(/\-/g, '');
      return /0[0-9]{9,10}/.test(tel);
    },
    validateMail (mailAdress) {
      return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mailAdress);
    },
    htmlspecialchars (text) {
      // XSS（Cross Site Scripting）対応
      return text.replace(/\</g, '&lt;').replace(/\>/g, '&gt;');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.contact_form {
  .formData_error {
    color: #ff6666;
    font-size: 14px;
  }
  .form_parts {
    display: flex;
    &:first-child {
      margin-top: 0;
    }
    @media (max-width: 768px) {
      display: block;
      margin-top: 25px;
    }
    .parts_ttl {
      width: 200px;
      @media (max-width: 768px) {
        width: 100%;
      }
      &.require:after {
        content: '必須項目';
        display: inline-block;
        margin-left: 10px;
        padding: 0 5px;
        color: #ffffff;
        font-size: 10px;
        vertical-align: middle;
        background-color: #ff6666;
        border-radius: 3px;
      }
    }
    .parts_ele {
      width: calc(100% - 200px);
      @media (max-width: 768px) {
        width: 100%;
        margin-top: 5px;
        margin-left: 0;
      }
      .error {
        margin-top: 5px;
        color: #ff0000;
        font-size: 14px;
      }
    }
  }
  input,
  textarea {
    appearance: none;
    width: 100%;
    padding: 10px;
    border: 1px solid #999;
    border-radius: 5px;
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }
  input::placeholder {
    color: #ccc;
  }
  textarea {
    resize: none;
    display: block;
    height: 100px;
    &::placeholder {
      color: #ccc;
    }
  }
  .form_btn {
    margin-top: 30px;
    text-align: center;
    .btn {
      appearance: none;
      min-width: 150px;
      padding: 10px 20px;
      border: none;
      border-radius: 5px;
      font-size: 18px;
      &:hover {
          opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InputTmp.vue